import { queryKeys } from '@/lib/query-keys';
import { invoiceClient } from '@/lib/api/ts-rest';
import { createLogger } from '@/lib/logger';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useCurrentOrganization } from './useOrganization';

/** Attach a billing detail to an invoice (invoiceId), or detach it (null). */
export const useLinkDetail = () => {
  const queryClient = useQueryClient();
  const { data: organization } = useCurrentOrganization();
  const log = createLogger('useLinkDetail');

  return useMutation({
    mutationFn: ({
      detailId,
      invoiceId,
    }: {
      detailId: string;
      invoiceId: string | null;
    }) => {
      if (!organization) {
        throw new Error('No organization selected');
      }
      return invoiceClient
        .linkDetail({
          params: { organizationId: organization.id, detailId },
          body: { invoiceId },
        })
        .then((res) => {
          if (res.status !== 200) throw new Error('Failed to link');
          return res.body;
        });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.invoices.list() });
      toast.success(
        variables.invoiceId ? 'Détail lié à la facture' : 'Détail délié'
      );
    },
    onError: (error) => {
      toast.error('La liaison a échoué');
      log.error('Failed to link billing detail', { error });
    },
  });
};
